if (!window.babyListButtonLoading) {
  function showBlLoadingUx(buttonEl) {
    var logoEl = buttonEl.querySelector('[data-babylist-label]');
    var loadingEl = buttonEl.querySelector('[data-babylist-loading]');

    if (logoEl && loadingEl) {
      logoEl.classList.add('hidden');
      loadingEl.classList.remove('hidden');
    }
  }

  function hideBlLoadingUx(buttonEl) {
    var logoEl = buttonEl.querySelector('[data-babylist-label]');
    var loadingEl = buttonEl.querySelector('[data-babylist-loading]');

    if (logoEl && loadingEl) {
      logoEl.classList.remove('hidden');
      loadingEl.classList.add('hidden');
    }
  }

  function stopLoadingUx(buttonEl) {
    var timeoutFallback;

    function handleIframeAddition(iframeNode) {
      iframeNode.addEventListener('load', function () {
        hideBlLoadingUx(buttonEl);
        observer.disconnect();

        if (timeoutFallback) {
          clearTimeout(timeoutFallback);
        }
      });
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function (node) {
            if (
              node.nodeType === Node.ELEMENT_NODE &&
              node.tagName.toLowerCase() === 'iframe' &&
              node.name === 'babylist_iframe'
            ) {
              handleIframeAddition(node);
            }
          });
        }
      });
    });

    var config = { childList: true, subtree: false };
    observer.observe(document.body, config);

    timeoutFallback = setTimeout(function () {
      hideBlLoadingUx(buttonEl);
    }, 6000);
  }

  function babyListButtonLoading(buttonEl) {
    try {
      showBlLoadingUx(buttonEl);
    } catch (ex) {
      // noop; don't break Babylist on UX error
    } finally {
      stopLoadingUx(buttonEl);
    }
  }

  window.babyListButtonLoading = babyListButtonLoading;
}
